module.exports = __webpack_public_path__ + "img/icon-linkedin.f5650bb0af41c9055bd9b770ba342df3.svg";